var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "attendance-event" } }, [
    _c("div", { staticClass: "attendance-img-wrapper" }, [
      _c("div", { staticClass: "apt" }),
      _c(
        "div",
        { staticClass: "d-grid" },
        _vm._l(7, function (i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "attendance_wrap",
              class: { seven: i === 7 },
            },
            [
              i === 7
                ? _c("div", { staticClass: "title" }, [_vm._v("7day")])
                : _vm._e(),
              _c("img", {
                attrs: {
                  src: `${
                    _vm.$s3
                  }/img/common/attendance/modal/event_${_vm.isActived(i, 0)}${
                    _vm.isDouble ? "_double" : ""
                  }.webp?${_vm.$ver}`,
                },
              }),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }